// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1150":"d9b5a3a3","6600":"5bab5c00","6938":"e17a7342","9617":"edbf4fb2"}[chunkId] + ".chunk.css";
};